import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { RevealLines } from "./Reveal";
import { scrollToSection } from "@/hooks/useLenis";

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const fade = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section ref={ref} className="relative h-[100svh] overflow-hidden" data-testid="hero-section">
      <motion.div
        initial={{ opacity: 0, scale: 1.05 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 2.4, delay: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0 z-[5] flex items-center justify-center pointer-events-none"
        data-testid="hero-logo-watermark"
      >
        <img
          src="/photos/logo-trimmed.webp"
          alt=""
          aria-hidden="true"
          className="w-[70vw] max-w-[820px] opacity-[0.28] animate-floaty select-none"
        />
      </motion.div>

      <motion.div style={{ opacity: fade }} className="relative z-10 h-full flex flex-col justify-end px-6 md:px-12 pb-14 md:pb-20">
        <RevealLines
          delay={0.35}
          className="mb-3"
          lineClassName="font-accent text-base md:text-lg tracking-[0.45em] uppercase text-[#C9A26B]"
          lines={["Editorial Wedding Photography"]}
        />
        <RevealLines
          delay={0.45}
          className="mb-6"
          lineClassName="text-xs tracking-[0.35em] uppercase text-[#F5F4F0]/80"
          lines={["Now booking 2027 — Italy · Denmark · Sweden"]}
        />
        <RevealLines
          delay={0.55}
          lineClassName="font-serif font-light text-[15.5vw] md:text-[11.5vw] leading-[0.88] tracking-tighter text-[#F5F4F0]"
          lines={["TAPESHIFT", "WEDDINGS"]}
        />
        <div className="mt-10 flex flex-col md:flex-row md:items-end justify-between gap-8 border-t border-white/15 pt-6">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.6 }}
            className="max-w-md text-sm md:text-base text-[#A3A3A3] leading-relaxed"
          >
            We photograph love the way it deserves to be remembered — in shadow,
            in grain, in the unrepeatable in-between.
          </motion.p>
          <motion.button
            data-testid="hero-scroll-btn"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.8 }}
            onClick={() => scrollToSection("#manifesto")}
            className="group flex items-center gap-4 text-xs tracking-[0.3em] uppercase text-[#F5F4F0] hover:text-[#C9A26B] transition-colors duration-500"
          >
            Scroll
            <span className="block w-10 h-px bg-[#C9A26B] group-hover:w-16 transition-[width] duration-500" />
          </motion.button>
        </div>
      </motion.div>
    </section>
  );
};
